import React from 'react';
import StarRating from './StarRating';
import { errorTypesText } from '../../util/validation';

const Long = ({ answersObj, typeFollowup, id, text, handleInput, handleBlur, required }) => {
  const isInvalid = answersObj[id].valid === false;
  return (
    <section id='feedback_comment_section' className={`form-group ${required ? 'required' : ''}`}>
      <div id={`feedback_${id}`} className={`feedback_input  ${isInvalid && 'error-input'}`}>
        <label hidden></label>
        <textarea
          id='feedback_textarea'
          type='text'
          name='long'
          className={`form-control ${typeFollowup ? 'followup' : ''}`}
          placeholder={`${text}${required ? '*' : ''}`}
          value={answersObj[id]?.value}
          onChange={(e) => handleInput(e.target.value, id, 'long', required)}
          onBlur={(e) => handleBlur(e.target.value, id, 'long', required)}
        ></textarea>
        {isInvalid ? (
          <p className='error-text'>{answersObj[id].errorMsg}</p>
        ) : (
          <span className={`charCount ${answersObj[id]?.value.length <= 1000 ? '' : 'errTextChars'}`}>
            {answersObj[id]?.value.length < 1001
              ? 1000 - answersObj[id]?.value.length + ' characters remaining'
              : 'too many characters'}
          </span>
        )}
      </div>
    </section>
  );
};

const Star = ({ answersObj, followupQst, id, text, handleInput, hover, handleHover, attemptedSubmit, required }) => {
  const isInvalid = answersObj[id].valid === false;
  return (
    <section id='feedback_stars_section' className={`form-group ${required ? 'required' : ''}`}>
      <div id={`feedback_${id}`} className={`feedback_input ${isInvalid && 'error-input'}`}>
        <label hidden></label>
        <p>{`${text}${required ? '*' : ''}`}</p>
        <StarRating
          id={id}
          rating={answersObj[id]?.value}
          handleInput={handleInput}
          hover={hover}
          handleHover={handleHover}
        />
        <p>1 = poor, 5 = excellent</p>
        {isInvalid && <p className='error-text'>{answersObj[id].errorMsg}</p>}
        {followupQst?.map((a) => {
          if (answersObj[id]?.value === a.followupAnswer) {
            return (
              <FeedbackQuestionOptions
                key={a.questionId + 'followup'}
                id={a.questionId}
                type={a.type}
                text={a.text}
                required={a.required}
                handleInput={handleInput}
                attemptedSubmit={attemptedSubmit}
                answersObj={answersObj}
                typeFollowup={true}
                options={a.questionOptions}
              />
            );
          }
        })}
      </div>
    </section>
  );
};

const Email = ({ answersObj, id, text, handleInput, handleBlur, siteFormat, required }) => {
  const isInvalid = answersObj[id].valid === false;
  return (
    <section id='feedback_email_section' className={`form-group ${required ? 'required' : ''}`}>
      <div id={`feedback_${id}`} className={`${isInvalid && 'error-input'} feedback_input`}>
        <label hidden></label>
        <input
          id='feedbackEmail'
          type='email'
          name='email'
          className='form-control'
          placeholder={`${siteFormat === 'mobile' ? 'Please enter your contact email' : text}${required ? '*' : ''}`}
          value={answersObj[id]?.value ? answersObj[id]?.value : ''}
          onChange={(e) => handleInput(e.target.value, id, 'email', required)}
          onBlur={(e) => handleBlur(e.target.value, id, 'email', required)}
        ></input>
        {isInvalid && <p className='error-text'>{answersObj[id].errorMsg}</p>}
      </div>
    </section>
  );
};

const FirstName = ({ answersObj, id, text, handleInput, handleBlur, required }) => {
  const isInvalid = answersObj[id].valid === false;
  return (
    <section id='feedback_name_section' className={`form-group ${required ? 'required' : ''}`}>
      <div id={`feedback_${id}`} className={`${isInvalid && 'error-input'} feedback_input`}>
        <label hidden></label>
        <input
          id='feedbackFName'
          type='fName'
          name='firstName'
          className='form-control'
          placeholder={`${text}${required ? '*' : ''}`}
          value={answersObj[id]?.value ? answersObj[id]?.value : ''}
          onChange={(e) => handleInput(e.target.value, id, 'firstName', required)}
          onBlur={(e) => handleBlur(e.target.value, id, 'firstName', required)}
        ></input>
        {isInvalid && <p className='error-text'>{answersObj[id]?.errorMsg}</p>}
      </div>
    </section>
  );
};

const LastName = ({ answersObj, id, text, handleInput, handleBlur, required }) => {
  const isInvalid = answersObj[id].valid === false;
  return (
    <section id='feedback_name_section' className={`form-group ${required ? 'required' : ''}`}>
      <div id={`feedback_${id}`} className={`${isInvalid && 'error-input'} feedback_input`}>
        <label hidden></label>
        <input
          id='feedbackLName'
          type='lName'
          name='lastName'
          className='form-control'
          placeholder={`${text}${required ? '*' : ''}`}
          value={answersObj[id]?.value ? answersObj[id]?.value : ''}
          onChange={(e) => handleInput(e.target.value, id, 'lastName', required)}
          onBlur={(e) => handleBlur(e.target.value, id, 'lastName', required)}
        ></input>
        {isInvalid && <p className='error-text'>{answersObj[id]?.errorMsg}</p>}
      </div>
    </section>
  );
};

const Phone = ({ answersObj, id, text, handleInput, handleBlur, required }) => {
  const isInvalid = answersObj[id].valid === false;

  const formatPhoneNumber = (inputString) => {
    var returnString = '';
    if (inputString.length > 0) {
      returnString = `(${inputString.substring(0, 3)}`;
    }
    if (inputString.length > 3) {
      returnString += `) ${inputString.substring(3, 6)}`;
    }
    if (inputString.length > 6) {
      returnString += `-${inputString.substring(6)}`;
    }
    return returnString;
  };
  return (
    <section id='feedback_phone_section' className={`form-group ${required ? 'required' : ''}`}>
      <div id={`feedback_${id}`} className={`${isInvalid && 'error-input'} feedback_input`}>
        <label hidden></label>
        <input
          id='feedbackPhone'
          type='phone'
          name='phone'
          maxLength={14}
          minLength={10}
          className='form-control'
          placeholder={`${text}${required ? '*' : ''}`}
          value={answersObj[id]?.value ? formatPhoneNumber(answersObj[id]?.value) : ''}
          onChange={(e) => handleInput(e.target.value, id, 'phone', required)}
          onBlur={(e) => handleBlur(e.target.value, id, 'phone', required)}
        ></input>
        {isInvalid && <p className='error-text'>{answersObj[id]?.errorMsg}</p>}
      </div>
    </section>
  );
};

const Short = ({ answersObj, id, text, handleInput, handleBlur, required }) => {
  const isInvalid = answersObj[id].valid === false;
  return (
    <section id='feedback_short_section' className={`form-group ${required ? 'required' : ''}`}>
      <div id={`feedback_${id}`} className={`${isInvalid && 'error-input'} feedback_input`}>
        <label hidden></label>
        <input
          type='short'
          name='short'
          placeholder={`${text}${required ? '*' : ''}`}
          className='form-control form-input-short'
          value={answersObj[id]?.value}
          onChange={(e) => handleInput(e.target.value, id, 'short', required)}
          onBlur={(e) => handleBlur(e.target.value, id, 'short', required)}
        ></input>
        {isInvalid ? (
          <p className='error-text'>{answersObj[id]?.errorMsg}</p>
        ) : (
          <span className='charCount'>{200 - answersObj[id]?.value.length} characters remaining</span>
        )}
      </div>
    </section>
  );
};

const Options = ({
  answersObj,
  followupQst,
  id,
  text,
  options,
  handleInput,
  handleBlur,
  attemptedSubmit,
  required,
}) => {
  const isInvalid = answersObj[id].valid === false;
  return (
    <section id='feedback_options_section' className={`form-group ${required ? 'required' : ''}`}>
      <div id={`feedback_${id}`} className={`${isInvalid && 'error-input'} feedback_input`}>
        <label hidden></label>
        <select
          className={`feedback_select_input form-control`}
          value={answersObj[id]?.value ? answersObj[id]?.value : '*'}
          onChange={(e) => handleInput(e.target.value, id, 'OPT', required)}
          onBlur={(e) => handleBlur(e.target.value, id, 'OPT', required)}
        >
          <option value='*' disabled hidden>
            {text}
          </option>
          {options &&
            options.map((a) => {
              return (
                <option key={a.optionId} value={a.value} id={a.optionId}>
                  {a.value}
                </option>
              );
            })}
        </select>
        {isInvalid && <p className='error-text'>{answersObj[id]?.errorMsg}</p>}
        {followupQst?.map((a) => {
          if (answersObj[id]?.value === a.followupAnswer) {
            return (
              <FeedbackQuestionOptions
                key={a.questionId + 'followup'}
                id={a.questionId}
                type={a.type}
                text={a.text}
                required={a.required}
                handleInput={handleInput}
                handleBlur={handleBlur}
                attemptedSubmit={attemptedSubmit}
                answersObj={answersObj}
                typeFollowup={true}
                options={a.questionOptions}
                storeList={a.storeList}
              />
            );
          }
        })}
      </div>
    </section>
  );
};

const YesOrNo = ({
  answersObj,
  id,
  text,
  followupQst,
  handleBlur,
  handleSelectYoN,
  handleInput,
  attemptedSubmit,
  required,
  type,
}) => {
  const isInvalid = answersObj[id].valid === false;
  const yesButton = (
    <button
      className={`yesOrNo_button btn-block btn ${answersObj[id]?.value === 'Y' ? 'btn-primary' : 'btn-secondary'}`}
      value={'Y'}
      onClick={(e) => {
        handleSelectYoN(e, id, 'Y', 'YN');
      }}
    >
      Yes
    </button>
  );
  const noButton = (
    <button
      className={`yesOrNo_button btn btn-block ${answersObj[id]?.value === 'N' ? 'btn-primary' : 'btn-secondary'}`}
      value={'N'}
      onClick={(e) => {
        handleSelectYoN(e, id, 'N', 'YN');
      }}
    >
      No
    </button>
  );
  return (
    <section id='feedback_yesOrNo_section' className={`form-group ${required ? 'required' : ''}`}>
      <div id={`feedback_${id}`} className={`${isInvalid && 'error-input'} feedback_input`}>
        <label hidden></label>
        <p>{`${text}${required ? '*' : ''}`}</p>
        <div id='yonContainer'>
          {type === 'NY' && noButton}
          {yesButton}
          {type === 'YN' && noButton}
        </div>
        {isInvalid && <p className='error-text'>{answersObj[id]?.errorMsg}</p>}
        {followupQst?.map((a) => {
          if (answersObj[id]?.value === a.followupAnswer) {
            return (
              <FeedbackQuestionOptions
                key={a.questionId + 'followup'}
                id={a.questionId}
                type={a.type}
                text={a.text}
                required={a.required}
                handleInput={handleInput}
                handleBlur={handleBlur}
                attemptedSubmit={attemptedSubmit}
                answersObj={answersObj}
                typeFollowup={true}
                options={a.questionOptions}
              />
            );
          }
        })}
      </div>
    </section>
  );
};

const Store = ({
  answersObj,
  id,
  storeList,
  selectedState,
  handleInput,
  handleBlur,
  handleSelectState,
  attemptedSubmit,
  required,
}) => {
  const stateList = [];
  storeList.length &&
    storeList.forEach((store) => {
      if (!stateList.includes(store.stateName)) {
        stateList.push(store.stateName);
      }
    });

  const storesByState = [...new Set(storeList.filter((a) => a.stateName === selectedState))];
  const selectedStateAreasRaw = [...new Set(storesByState.map((curr) => curr.marketTag))];
  const selectedStateAreasClean = selectedStateAreasRaw.map((word) => {
    if (word.includes('\|')) {
      return word.substring(0, word.indexOf('\|'));
    } else return word;
  });

  const isInvalidState = required && answersObj[id].valid === false && !selectedState;
  const isInvalidStore = answersObj[id].valid === false && attemptedSubmit;

  return (
    <div id='feedback_state_store_section'>
      <section id='feedback_select_state_section' className={`form-group ${required ? 'required' : ''}`}>
        <div className={`feedback_input ${isInvalidState && 'error-input'}`}>
          <select
            className={`feedback_select_input form-control`}
            onChange={(e) => {
              handleSelectState(e.target.value);
            }}
            value={selectedState ? selectedState : '*'}
            onBlur={(e) => handleBlur(e.target.value, id, 'stateDD', required)}
          >
            <option value='*' disabled hidden>{`State${required ? '*' : ''}`}</option>
            {stateList.length > 0 &&
              stateList.map((a, idx) => {
                return (
                  <option key={idx} value={a} id={a}>
                    {a}
                  </option>
                );
              })}
          </select>
          {isInvalidState && <p className='error-text'>{errorTypesText.requiredState}</p>}
        </div>
      </section>
      {selectedState && (
        <section id='feedback_select_store_section' className={`form-group ${required ? 'required' : ''}`}>
          <div className={`feedback_input ${isInvalidStore && 'error-input'}`}>
            <select
              className={`feedback_select_input form-control`}
              onChange={(e) => handleInput(e.target.value, id, 'storeDD', required)}
              value={answersObj[id]?.value ? answersObj[id]?.value : '*'}
              onBlur={(e) => handleBlur(e.target.value, id, 'storeDD', required)}
            >
              <option value='*' disabled hidden>{`Store${required ? '*' : ''}`}</option>
              {storeList.length &&
                selectedState &&
                selectedStateAreasClean.map((area) => {
                  return (
                    <optgroup key={area} label={area}>
                      {storesByState
                        .filter((store) => store.marketTag.includes(area))
                        .map((s) => {
                          return (
                            <option key={s.identifier} value={s.identifier}>
                              {s.name}
                            </option>
                          );
                        })}
                    </optgroup>
                  );
                })}
            </select>
            {isInvalidStore && <p className='error-text'>{errorTypesText.requiredStore}</p>}
          </div>
        </section>
      )}
    </div>
  );
};

const FeedbackQuestionOptions = ({
  type,
  id,
  text,
  handleInput,
  handleBlur,
  hover,
  followupQst,
  handleHover,
  storeList,
  selectedState,
  handleSelectState,
  required,
  handleSelectYoN,
  attemptedSubmit,
  siteFormat,
  answersObj,
  options,
  typeFollowup,
}) => {
  switch (type) {
    case 'LONG':
      return (
        <Long
          answersObj={answersObj}
          typeFollowup={typeFollowup}
          id={id}
          text={text}
          handleInput={handleInput}
          handleBlur={handleBlur}
          attemptedSubmit={attemptedSubmit}
          required={required}
        />
      );
    case 'STAR':
      return (
        <Star
          answersObj={answersObj}
          followupQst={followupQst}
          id={id}
          text={text}
          handleInput={handleInput}
          handleHover={handleHover}
          hover={hover}
          attemptedSubmit={attemptedSubmit}
          required={required}
        />
      );
    case 'EMAIL':
      return (
        <Email
          answersObj={answersObj}
          id={id}
          text={text}
          handleInput={handleInput}
          handleBlur={handleBlur}
          attemptedSubmit={attemptedSubmit}
          siteFormat={siteFormat}
          required={required}
        />
      );
    case 'FNAME':
      return (
        <FirstName
          answersObj={answersObj}
          id={id}
          text={text}
          handleInput={handleInput}
          handleBlur={handleBlur}
          attemptedSubmit={attemptedSubmit}
          siteFormat={siteFormat}
          required={required}
        />
      );
    case 'LNAME':
      return (
        <LastName
          answersObj={answersObj}
          id={id}
          text={text}
          handleInput={handleInput}
          handleBlur={handleBlur}
          attemptedSubmit={attemptedSubmit}
          siteFormat={siteFormat}
          required={required}
        />
      );
    case 'PHONE':
      return (
        <Phone
          answersObj={answersObj}
          id={id}
          text={text}
          handleInput={handleInput}
          handleBlur={handleBlur}
          attemptedSubmit={attemptedSubmit}
          siteFormat={siteFormat}
          required={required}
        />
      );
    case 'STORE':
      return (
        <Store
          answersObj={answersObj}
          id={id}
          storeList={storeList}
          selectedState={selectedState}
          handleSelectState={handleSelectState}
          handleInput={handleInput}
          handleBlur={handleBlur}
          attemptedSubmit={attemptedSubmit}
          required={required}
        />
      );
    case 'SHORT':
      return (
        <Short
          answersObj={answersObj}
          id={id}
          text={text}
          handleInput={handleInput}
          handleBlur={handleBlur}
          attemptedSubmit={attemptedSubmit}
          required={required}
        />
      );
    case 'OPT':
      return (
        <Options
          answersObj={answersObj}
          followupQst={followupQst}
          id={id}
          text={text}
          handleInput={handleInput}
          handleBlur={handleBlur}
          attemptedSubmit={attemptedSubmit}
          required={required}
          options={options}
        />
      );
    case 'NY':
      return (
        <YesOrNo
          answersObj={answersObj}
          followupQst={followupQst}
          handleInput={handleInput}
          id={id}
          text={text}
          handleSelectYoN={handleSelectYoN}
          attemptedSubmit={attemptedSubmit}
          required={required}
          type={type}
          handleBlur={handleBlur}
        />
      );
    case 'YN':
      return (
        <YesOrNo
          answersObj={answersObj}
          followupQst={followupQst}
          handleInput={handleInput}
          id={id}
          text={text}
          handleSelectYoN={handleSelectYoN}
          attemptedSubmit={attemptedSubmit}
          required={required}
          type={type}
          handleBlur={handleBlur}
        />
      );
    default:
      return <></>;
  }
};

export default FeedbackQuestionOptions;
